import sidemenucss from "../../css/sidemenu.module.css";
import { useHistory } from "react-router-dom";
import { getInvestmentRegisterForms } from "../../../WorkSpace/Components/ApiServices/apiHandler";
import { useState, useEffect } from "react";

const IRMenu = ({ activeTab, registerID }) => {

   const [registerName, setRegisterName] = useState("");
 //const [companyName, setCompanyName] = useState("");
    let history = useHistory();

    const handleClick = (Link) => {
        history.push(Link);
    };

    useEffect(() => {
        getIRData();
    }, [registerID])

  
    const getIRData = () => {
     getInvestmentRegisterForms(registerID)
    .then(response => {
      const data = response.data?.investmentRegister;

      setRegisterName(data?.name);
      //setCompanyName(data?.linkedCompaniesData?.[0]?.company_name);
    })
    .catch(error => {
      console.log("error", error);
    });
};

    const menuItems = [
        {
            label: "Dashboard",
            pagelink: `/myfinV2/IR/dashboard/${registerID}`,
        },
        {
            label: "Investments",
            pagelink: `/detailsIR/${registerID}`
        },
        {
            label: "Share Capital",
            pagelink: `/myfinV2/IR/sharecapital/${registerID}`,
        },
        {
            label: "Key Managerial Persons",
            pagelink: `/myfinV2/IR/keymanagerialpersons/${registerID}`
        },
        // {
        //     label: "Repository",
        //     pagelink: `/myfinV2/IR/repository/${registerID}`
        // },
    ];

    return (

        <div className={`${sidemenucss.sidemenuContainer} ${sidemenucss.sidemenuBackgroundClr}`}>
            <div className={sidemenucss.sidemenuHeader}>
              <span className={sidemenucss.sidemenuTitle}>{registerName}</span>

             {/* {activeTab !== "Investments" && (
                <span className={sidemenucss.sidemenuSubTitle}>{companyName}</span>
              )} */}
              </div>
            <div className={`${sidemenucss.sidemenuContent} ${sidemenucss.sidemenuLinksFontSize} ${sidemenucss.sidemenuContentTop}`}>
                <ul className={sidemenucss.sidemenuList}>
                    {menuItems.map((item, index) => (
                        <div key={index}>
                            <li
                                onClick={() => {
                                    if (item.pagelink) {
                                        setTimeout(() => handleClick(item.pagelink), 100);
                                    }
                                }}
                                className={`${sidemenucss.sidemenuItem} ${activeTab === item.label ? sidemenucss.sidemenuItemActive : ''}`}
                            >
                                {item.label}
                            </li>
                        </div>
                    ))}
                </ul>
            </div>
        </div>


    );
};

export default IRMenu;
